import React, { useState } from 'react'
import { Portal } from '@hub/portal'
import { Box } from '@hub/box'
import { useToken } from '@hub/design-system-base'
import Color from 'color'

export const Overlay: React.FC<{
  isOpen: boolean
  onMouseEnter: React.MouseEventHandler
  megaMenuPortalRef: React.RefObject<HTMLElement>
}> = ({ isOpen, onMouseEnter, megaMenuPortalRef }) => {
  const menuOverlayZIndex = useToken('zIndices', 'menuOverlay')
  const [overlayTop, setOverlayTop] = useState(0)
  const OVERLAY_OFFSET = 1
  React.useEffect(() => {
    if (!megaMenuPortalRef?.current) {
      return
    }

    setOverlayTop(
      // Adding 1px to push the overlay down a little to be safe otherwise it may add a gray line at the edge
      megaMenuPortalRef?.current?.getBoundingClientRect().bottom -
        (document?.querySelector('body')?.getBoundingClientRect()?.top || 0) +
        OVERLAY_OFFSET
    )
  }, [isOpen, megaMenuPortalRef])

  const OverlayBackgroundColor = Color(useToken('colors', 'licorice'))
    .alpha(0.8) // eslint-disable-line no-magic-numbers
    .rgb()
    .string()

  if (!isOpen) {
    return null
  }
  return (
    <Portal>
      <Box
        sx={{
          position: 'absolute',
          backgroundColor: OverlayBackgroundColor,
          top: overlayTop,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: menuOverlayZIndex,
        }}
        onMouseEnter={onMouseEnter}
      />
    </Portal>
  )
}
